/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Text } from '@components/atoms'
import { LogedInUserInfo } from '@components/molecules/user/LogedInUserInfo'

import packageJson from '../../../../package.json'
import { grey } from '@mui/material/colors'

export const DrawerBottomView = () => {
	return (
		<View css={style} style={{ borderTop: `1px solid ${grey[200]}` }}>
			<LogedInUserInfo />

			<View className="versionView">
				<Text category="c1" hint="500">{`v ${packageJson.version}`}</Text>
			</View>
		</View>
	)
}

const style = css({
	position: 'absolute',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'flex-start',
	width: '100%',
	minHeight: '3.9rem',
	bottom: 0,
	paddingLeft: '0.5rem',
	paddingRight: '0.5rem',

	'.versionView': {
		position: 'absolute',
		right: '1rem',
	},
})
